import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/accusoft': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M322.1 252c-1.7 1.6-89.6 82.5-90.2 83.3l-92.6 33.8c-4.8 2-7.6 3.7-7 8.9 0.2 1.5 0.6 22.6 1 27.7-0.7 0.5-0.1 0-0.6 0.6 0 0-113.7 36.6-114.5 36.6-14.1 5.1-22.7 8.3-15.7-1.7 1.3-1.8 234.4-231.6 243.4-240.9 13-13.5 25-15.1 25-15.1l51.2 65.8v1zM482.2 372.1c-5.7-6.9-232.2-297.1-239.9-306.6-13.7-17.2 0-16.8 19.2-16.9 9.7-0.1 106.3-0.6 116.5-0.6 24.1-0.1 28.7 0.6 38.4 12.8 2.1 2.7 205.1 245.8 207.2 248.3 5.5 6.7 15.2 19.1 7.2 23.4-2.4 1.3-114.6 47.7-117.8 48.9-10.1 4-17.5 6.8-30.8-9.3zM634.9 373.7c6 1.4 7.1 4.2 1.7 8.2-2 1.4-123.7 76.6-125.8 77.8-15.1 8.8-38 1.6-53.6-1.7-7.1-1.5-305.3-68.3-308-69.1-2.6-0.9-4.4-1-4.6-3.5-0.3-4 6-5.6 11.1-7.6 5-1.9 145.3-52.6 150.2-54.7 4.8-2.1 11.3-2.7 14.4-2.9 4.9-0.3 59.9 8.4 65.3 9.3l57.1 74c9.8 11.4 20.7 21.9 36.7 14.6 2.5-1.2 117.5-51.6 117.5-51.6 13.4 2.5 35.7 6.9 38 7.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/accusoft.js
// module id = 691
// module chunks = 0